import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {branches_settings} from '../branches_settings';
import {BranchesSettingsService} from '../branches_settings.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from '../../../../components/app-arc';
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {UserService} from '../../../../services';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        TranslateModule.forChild()
    ],
    declarations: [
        BranchesSettingsShowComponent
    ],
    entryComponents: [
        BranchesSettingsShowComponent
    ],
    exports: [],
    providers: [SharedService, BranchesSettingsService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})
@Component({
    selector: 'app-branches_settings-show',
    templateUrl: './branches_settings-show.component.html',
    styleUrls: ['./branches_settings-show.component.scss'],
    providers: [BranchesSettingsService, ConfirmationService, MessageService]
})


export class BranchesSettingsShowComponent implements OnInit, AfterViewInit {

  id: string;
  branch_name: string;
  branch_name_old: string;
  branch = new branches_settings();
  filter: any;
  @Input() delId;
  @Input() scrId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;
  modalRef: NgbModalRef;
  applog: AppLogComponent;
  @Input() refShow;

  alltreeacc: any[] = [];
  alltreecost: any[] = [];
  allusers: any[] = [];
  allcurrencies: any[] = [];
  SelectedUsers: any[] = [];
  SelectedUsers_old: any[] = [];
  is_supervisor: any[] = [];
  is_supervisor_old: any[] = [];

  restoreInv: any;
  Selected_branches: any[] = [];
  Selected_branches_old: any[] = [];

  branchForm: FormGroup;
  private sub: any;
  msgs: Message[] = [];
  statusVal = [{'val': 1, 'title': 'Active'}, {'val': 2, 'title': 'Inactive'}];

  private _editButton: any;
  private _deleteButton: any;
  private _searchButton: any;
  private _newButton: any;
  private _printButton: any;
  hiddenFields: any[] = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private branchesSettingsService: BranchesSettingsService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
                this.msgs = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(BranchesSettingsShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('branches_settings');
    }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();

                return true;
            }
        };
        JSON.parse(localStorage.getItem('filter'));

        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.branch;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData) {

            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._searchButton = document.getElementById('searchButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');

            if (this._editButton) {
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches_settings/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteBranch(this.branch);
                });
            }
            if (this._newButton) {
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches_settings']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/branches_settings/search']);
                });
            }
        }
    }

    ngOnInit() {

      this.userService.getAllUsers().subscribe(
        group => {
          this.allusers = group.userslist;
        });

        this.msgs=[];
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.branchForm = new FormGroup({
          id: new FormControl({value: '', disabled: true}, Validators.required),
          branch_id: new FormControl({value: '', disabled: true}, Validators.required),
          branch_name: new FormControl({value: '', disabled: true}, Validators.required),
        });

        this.fieldsControl('setting.branches_settings');

        if(this.id) {
          this.msgs=[];
          this.activeModal.dismiss('');
          this.oldData = false;
          this.newData = false;
          this.newDatap = true;

          this.delId = false;
          localStorage.removeItem('filter');
          const msg = JSON.parse(localStorage.getItem('showMessages'));
          if (msg) {
              localStorage.removeItem('showMessages');
              this.msgs = msg;
              this.msgs=[];
          }
          this.branchesSettingsService.getById(this.id).subscribe(
              data => {
                this.id = data.id;
                this.branch = data;
                this.branch_name = data.branch.name;
                this.branchForm.patchValue({
                  id: this.id,
                  name: data.branch.name,
                  branch_id: data.branch.id,
                });
                this.SelectedUsers = data.allusers;
                for (let bran in  data.allusers2) {
                  console.log(data.allusers2[bran].is_supervisor);
                  this.is_supervisor[bran] = data.supervisors[bran];
                }
              }, error => {
                  console.log(error);
              }
          );
        }
        if(this.scrId) {
          this.oldData = false;
          this.newData = false;
          this.delId = false;

          this.branchesSettingsService.getById(this.scrId).subscribe(
              data => {
                this.id = data.id;
                this.branch = data;
                this.branch_name = data.branch.name;
                this.branchForm.patchValue({
                  id: this.id,
                  name: data.branch.name,
                  branch_id: data.branch.id,
                });
              }, error => {
                  console.log(error);
              }
          );
        }
        if(this.delId) {
          this.oldData = false;
          this.newData = false;
          this.newDatap = !this.newDatap ;
          this.branchesSettingsService.getTrashedById(this.delId).subscribe(
            data => {
                this.id = data.id;
                this.branch = data;
                this.branch_name = data.branch.name;
                this.branchForm.patchValue({
                  id: data.id,
                  name: data.branch.name,
                  branch_id: data.branch.id,
                });
            }, error => {
                console.log(error);
            }
          );
        }

        if(this.oldData && this.newData) {
          // console.log(this.newData, this.oldData);
          this.branch = this.newData;
          this.branch_name = this.oldData.branch.name;
          this.branch_name_old = this.newData.branch.name;
          this.restoreInv = this.oldData;

          this.restoreInv.branch_users = JSON.stringify(this.oldData.allusers2);
          this.restoreInv.supervisors = JSON.stringify(this.oldData.supervisors);
          this.SelectedUsers = this.newData.allusers;
          console.log('this.newData.allusers')
          console.log(this.newData.allusers)
          for (let bran in  this.newData.allusers2) {
            this.is_supervisor[bran] = this.newData.supervisors[bran];
          }

          this.SelectedUsers_old = this.oldData.allusers;
          for (let bran in  this.oldData.allusers2) {
            this.is_supervisor_old[bran] = this.oldData.supervisors[bran];
          }
          this.branch = this.newData;
          this.branchForm.patchValue({
            id: this.newData.id,
            name: this.newData.branch.name,
            branch_id: this.newData.branch_id
          });
        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }

    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('setting.branches.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteBranch(branch: branches_settings) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
              if (branch) {
                this.branchesSettingsService.delete(branch.id).subscribe(
                  res => {
                    this.msgs = [];
                    if (res.result == false) {
                      this.msgs.push({
                        severity: 'error',
                        summary: '',
                        detail: this.translate.instant(res.message)
                      });
                    } else {
                      this.msgs.push({
                        severity: 'success',
                        summary: '',
                        detail: this.translate.instant('Delete completed')
                      });
                      setTimeout(() => {
                          this.router.navigate(['/branches']);
                      }, 1000);
                    }
                    localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                  }
                );
              }
            }
        });
    }

    recoverEdit(branch: branches_settings) {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Undo Edit'),
        message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
        icon: 'fa fa-undo',
        accept: () => {
          if (branch) {
            this.branchesSettingsService.update(branch).subscribe(
              res => {
                this.msgs = [];
                this.msgs.push({
                  severity: 'success',
                  summary: '',
                  detail: this.translate.instant('Data returned')
                });
                this.activeModal.close('done');
                this.router.navigate(['/branches_settings/show', branch.id]);
              }
            );
          }
        }
      });
    }

    undotrashed() {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Undo Delete'),
        message: this.translate.instant('Are you sure about recover deleted item?'),
        icon: 'fa fa-undo',
        accept: () => {
          if (this.delId) {
            this.branchesSettingsService.restoreTrashedById(this.delId).subscribe(
              res => {
                this.msgs = [];
                this.msgs.push({
                    severity: 'success',
                    summary: '',
                    detail: this.translate.instant('Deleted item recovered')
                });
                this.activeModal.dismiss('close click');
                this.router.navigate(['/branches_settings/list']);
              }
            );
          }
        }
      });
    }

    showattachement(row_id: string) {
        console.log(row_id)
        if (row_id) {
          const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
          };
          const modalRef = this.modalService.open(AppArcComponent, options);
          modalRef.componentInstance.rowId = row_id;
          modalRef.componentInstance.screenName = this.modelName;
        }
    }

    showHistory(row_id: string) {
      if (row_id) {
        const modalRef = this.modalService.open(AppLogComponent);
        modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = BranchesSettingsShowComponent;
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/branches_settings/branches_settings-show/branches_settings-show.component.ts